import { render } from "./LineChartA.vue?vue&type=template&id=5a04e3bc&scoped=true"
import script from "./LineChartA.vue?vue&type=script&lang=ts"
export * from "./LineChartA.vue?vue&type=script&lang=ts"
script.render = render
script.__scopeId = "data-v-5a04e3bc"

export default script